//import Vue from 'vue'
const state = {
    blockScreenActive: false
}
// getters
const getters = {
    isBlockScreenActive(state) {
        return state.blockScreenActive;
    },
}

// actions
const actions = {
    showBlockScreen({ commit }, data) {
        commit('showBlockScreen', data)
    },
}

// mutations
const mutations = {
    showBlockScreen(state, playload) {
        state.blockScreenActive = playload
    }
}

export default {
    namespaced: false,
    state,
    getters,
    actions,
    mutations
}